import { _RULES } from "@/store/_RULES";
import { _GROUPS } from "@/store/_PERMISSIONS";

// -- FIELDS
const _FIELDS = [
  {
    label: "Utilizador",
    name: "id_utilizador",
    type: "array",
    store: "utilizador",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: [_RULES.required]
  },
  {
    title: "Data pedido",
    type: "data",
    name: "data_pedido",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required],
  },
  {
    title: "Data Resultado",
    type: "data",
    name: "data_resultado",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [],
  },
  {
    label: "Galardão",
    name: "id_galardao",
    type: "array",
    store: 'galardao',
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: [_RULES.required]
  },
];

// -- HEADERS
const _HEADERS = [
  {
    text: "Utilizador",
    align: "left",
    value: "utilizador"
  },
  {
    text: "Galardão",
    align: "left",
    value: "galardao"
  },
  {
    text: "Dádivas",
    align: "left",
    value: "dadivas"
  },
  {
    text: "Instituição",
    align: "left",
    value: "instituicao"
  },
  {
    text: "Estado",
    align: "left",
    value: "estado"
  },
  {
    text: "Ações",
    value: "action"
  }
];

const GALARDAO_PEDIDO = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
};

export default GALARDAO_PEDIDO;
